// ContactListShimmer.styles.ts
import { IStyle, mergeStyleSets } from "@fluentui/react";

export const contactListShimmerStyles = mergeStyleSets({
  shimmerDiv: {
    display: "flex",
    paddingBottom: 10
  } as IStyle,
  shimmer1: {
    marginTop: 15,
    width: 410,
    paddingLeft: 5,
    paddingBottom: 5
  } as IStyle,
  shimmer2: {
    marginTop: 10,
    width: 50,
    paddingLeft: 5,
    paddingRight: 5
  } as IStyle,
  shimmer3: {
    width: 350,
    paddingTop: 5,
    paddingLeft: 5,
    paddingBottom: 5
  } as IStyle,
  shimmer4: {
    width: 250,
    paddingLeft: 5,
    paddingTop: 5
  } as IStyle
});
